import { css } from 'emotion';

const placeholder = css`
  > div {
    margin: 20px;
  }
`;

export default {
  placeholder,
};
